import { FavoriteRequests } from '@/services/http/favorites-requests';

export default {
  namespaced: true,
  state: {
    autopayment: null,
    checkFields: null,
    autoPaymentsShort: [],
    autoPaymentsShortLoading: true,
    autoPayments: [],
  },
  getters: {
    getAutoPaymentsList(state) {
      return state.autoPayments;
    },
    getLatestAutoPaymentsShort(state) {
      return state.autoPaymentsShort;
    },
  },
  mutations: {
    setAutoPaymentsList(state, payload) {
      state.autoPayments = payload;
    },
    setLatestAutoPaymentsShort(state, payload) {
      state.autoPaymentsShort = payload?.data?.favorites?.content || [];
    },
    updateAutoPaymentItem(state, updatedItem) {
      const modifiedList = state.autoPayments.map((item) => (item.id !== updatedItem.id ? item : updatedItem));
      state.autoPayments = modifiedList;
    },
    deleteAutoPaymentItem(state, deleteItem) {
      const modifiedList = state.autoPayments.filter((item) => item.id !== deleteItem.id);
      state.autoPayments = modifiedList;
    },
    updateAutopaymentShortItem(state, updatedItem) {
      const modifiedList = state.autoPaymentsShort.map((item) => (item.id !== updatedItem.id ? item : updatedItem));
      state.autoPaymentsShort = modifiedList;
    },
  },
  actions: {
    setAutoPaymentsList({ commit }, autopayments) {
      commit('setAutoPaymentsList', autopayments);
    },
    updateAutoPaymentItem({ commit }, { type, payload }) {
      if (type === 'list') {
        commit('updateAutoPaymentItem', payload);
      } else {
        commit('updateAutopaymentShortItem', payload);
      }
    },
    deleteAutoPaymentItem({ commit }, payload) {
      commit('deleteAutoPaymentItem', payload);
    },
    async getLatestAutoPaymentsShort({ commit, state }) {
      state.autoPaymentsShortLoading = true;

      const [response] = await FavoriteRequests.getFavorites(
        {
          filter: 'AUTO_PAYMENT',
          size: 5,
          page: 1,
        },
      );
      commit('setLatestAutoPaymentsShort', response);
      state.autoPaymentsShortLoading = false;
      return response;
    },
  },
};
